import { Box, Typography } from "@mui/material";
 import EmailTable from "src/sections/Email/EmailTable";

const Email = () => {
  return (
    <>
      <Box 
        sx={{
          padding: "64px 20px 0px 20px",
          height: '100vh',
          display: "flex",
          flexDirection: "column", 
          marginLeft:'55px',
          backgroundColor:"#f0f0f0"
        }}
      >
      
        < EmailTable/>
        
             </Box>
    </>
  );
};

export default Email;


